// Pasek podzakładek sekcji „Raporty meczowe": Mecze (lista StatsBomb) /
// Podsumowanie okresowe / LIVE (sesje tagowania) / SFG / Legia II (2 liga). Osobny od SubTabLayout, bo „Mecze" nie może
// być aktywne na /raporty/live (prefiks /raporty obejmowałby /raporty/live).
// Widoki-szczegóły (/raporty/:id, /raporty/live/:id) są POZA paskiem — mają własne
// linki „← wróć". No-print. Przy włączonej fladze AUTH_REQUIRED pigułki stron
// bez dostępu znikają (sekcje: lib/access.ts).

import { Link, Outlet, useLocation } from 'react-router-dom'

import { useAccess } from '../lib/session'

const PILL = 'rounded-full px-3.5 py-1.5 text-[13px] font-semibold transition-colors'

export function RaportyTabsLayout() {
  const { pathname } = useLocation()
  const { canView } = useAccess()
  const isLive = pathname === '/raporty/live' || pathname.startsWith('/raporty/live/')
  const isSfg = pathname === '/raporty/sfg'
  const isRanking = pathname === '/raporty/podsumowanie' || pathname === '/raporty/ranking'
  const isReserves = pathname === '/raporty/legia-ii'
  const cls = (on: boolean) =>
    `${PILL} ${on ? 'bg-forest-800 text-white shadow-sm' : 'text-ink-500 hover:bg-ink-100 hover:text-ink-900'}`
  return (
    <>
      <div className="no-print border-b border-ink-100 bg-white">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-1.5 px-6 py-2">
          {canView('/raporty') && <Link to="/raporty" className={cls(!isLive && !isSfg && !isRanking && !isReserves)}>Mecze</Link>}
          {canView('/raporty/podsumowanie') && <Link to="/raporty/podsumowanie" className={cls(isRanking)}>Podsumowanie okresowe</Link>}
          {canView('/raporty/live') && <Link to="/raporty/live" className={cls(isLive)}>LIVE</Link>}
          {canView('/raporty/sfg') && <Link to="/raporty/sfg" className={cls(isSfg)}>SFG</Link>}
          {canView('/raporty/legia-ii') && <Link to="/raporty/legia-ii" className={cls(isReserves)}>Legia II</Link>}
        </div>
      </div>
      <Outlet />
    </>
  )
}
